/* eslint-disable camelcase */
import { ReverseMap } from 'shared/utils/tsHelpers'

export interface IProfile {
  id: number
  username: string
  dateJoined: string
  balanceCurrency: Date
  balance: string
  isBanned: boolean
}

export interface IServerProfile {
  id: number
  username: string
  date_joined: string
  balance_currency: Date
  balance: string
  is_banned: boolean
}

export interface IUserInfo {
  firstName: string
  lastName: string
  gender?: string
  email?: string
  residenceDocument?: string
  dateOfBirth: string
  country: string
  city?: string
  mobileNumber?: string
  streetAddress?: string
  isConfirmedMail: boolean
}

export interface IUserInfoPayload {
  firstName: string
  lastName: string
  dateOfBirth: string
  mobileNumber?: string
  postalCode?: string
  streetAddress: string
  country?: string
  residenceDocument?: string
  state?: string
  gender?: string
  city?: string
}

export interface IServerUserInfo {
  first_name: string
  last_name: string
  gender?: string
  email?: string
  date_of_birth: string
  country: string
  city?: string
  residence_document?: string
  street_address?: string
  mobile_number?: string
  is_email_verified?: boolean
}

export const ProfileTabs = {
  PROFILE: 'profile',
  BET_HISTORY: 'betHistory',
  BET_HISTORY_1: 'betHistory_1',
  BET_HISTORY_2: 'betHistory_2',
  BET_HISTORY_3: 'betHistory_3',
  BET_HISTORY_4: 'betHistory_4',
  BONUSES: 'bonuses',
  TRANSACTIONS: 'transactions',
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
  SLOTS_HISTORY: 'slotsHistory',
  SPIN_HISTORY: 'spinHistory',
  CHANGE_PASSWORD: 'changePassword',
} as const

export type ProfileTabsType = ReverseMap<typeof ProfileTabs>

export const SideMenuTabs = {
  ...ProfileTabs,
} as const

export type SideMenuTabsType = ReverseMap<typeof SideMenuTabs>

export enum DocumentTypes {
  PASSPORT = 'P',
  DRIVER_LICENSE = 'DL',
  NATIONAL_ID = 'ID',
}